<template>
	<v-card>
		<v-card-text>
			<v-form ref="form">
				<z-oferta></z-oferta>
				<v-checkbox 
					v-model="item.agree"
					label="З умовами публічної оферти ознайомлений"
					hide-details
					single-line
					:rules="[rules.ofertaagree]"
					@update:modelValue="item.changed=true"
				></v-checkbox>
			</v-form>
		</v-card-text>
	</v-card>
</template>

<script>
import mixin from './mixin/main'
import zOferta from '@/components/Oferta3'

export default {
	mixins: [mixin],
	components: { zOferta },
}
</script>
